import {
  Divider,
  Row,
  Typography,
  Input,
  Button,
  Table,
  Modal,
  Form,
  Col,
  message,
  Select,
  Menu,
  Dropdown,
  InputNumber,
} from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined, MoreOutlined } from "@ant-design/icons";
import exportCSV from "assets/icons/exportcsv.svg";
import { Link } from "react-router-dom";
import {
  disableSubmitButton,
  emailPattern,
  formatCSVData,
  formatNumberUS,
  servicesNamePattern,
  tenDigit,
  urlPattern,
} from "utility/constant";
import { CSVLink } from "react-csv";
import { CreateLab, DeleteLab, ListLabs } from "utility/action";
import SuccessModel from "utility/SuccessModel";
import { useCallback } from "react";
import search from "utility/search";
import DeleteModal from "utility/DeleteModal";
import { DeleteService } from "utility/DeleteService";
import { handleStatusChange } from "utility/StatusChange";
import TableSkeleton from "utility/TableSkeleton";

export default function Labs() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [labData, setLabData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [dataSource, setDataSource] = useState(labData);
  const [csvData, setCsvData] = useState([]);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [deleteModelPrompt, setDeleteModelPrompt] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [deleteId, setDeleteId] = useState("");
  const { Option } = Select;

  const handleFormChange = disableSubmitButton(["labName"])(
    form,
    setSubmitDisabled
  );

  const labelKeyMap = {
    "Lab Facility ID": "labFacilityID",
    "Lab Center Name": "labName",
    "Google Map Link": "labMapSource",
    "Lab Service Link": "labServicesLink",
    "About Lab": "aboutLab",
    Address: "labOfficeAdd",
    City: "labOfficeCity",
    State: "labOfficeState",
    Zip: "labOfficeZip",
    Phone: "labOfficePhone",
    Website: "labWebsite",
    "Google Rating": "labGoogleRating",
    "Facebook Rating": "labFaceBookRating",
    "Lab type": "labType",
  };

  const { headers, resData } = formatCSVData(labelKeyMap, csvData);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setSuccessModel(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSuccessModel(false);
  };

  const setLabrows = function (row) {
    return {
      key: row?.id,
      createdAt: row?.createdAt,
      searchByName: row?.searchByName,
      Action: row?.id,
      LabName: row?.labName,
      Phone: row?.labOfficePhone,
      Website: row?.labWebsite,
      Email: row?.labEmail,
    };
  };

  const columns = [
    {
      title: "Lab Name",
      dataIndex: "LabName",
    },
    {
      title: "Lab Website",
      dataIndex: "Website",
    },

    {
      title: "Phone",
      dataIndex: "Phone",
      render: (number) => {
        return formatNumberUS(number);
      },
    },
    {
      title: "Email",
      dataIndex: "Email",
    },

    {
      title: "",
      dataIndex: "Action",
      className: "actions",
      render: (id) => {
        return (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item key={1}>
                  <Link to="/lab-detail" state={{ id: id }}>
                    Edit
                  </Link>
                </Menu.Item>
                <Menu.Item key={2}>
                  <Link
                    rel="noopener noreferrer"
                    onClick={() => {
                      setDeleteModelPrompt(true);
                      setDeleteId(id);
                    }}
                  >
                    Delete
                  </Link>
                </Menu.Item>
              </Menu>
            }
            overlayClassName="download-btn"
            placement="bottomRight"
          >
            <MoreOutlined />
          </Dropdown>
        );
      },
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ListLabs(999);
      const data = response.map((row) => setLabrows(row));
      data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setLabData(data);
      setDataSource(data);
      setCsvData(response);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const createlabCenter = async (values) => {
    try {
      setCreateLoading(true);
      setDeleteId("");
      const inputData = {
        labName: values?.labName,
        searchByName: (values?.labName).toLowerCase(),
        labEmail: values?.labEmail,
        labOfficePhone: values?.labOfficePhone,
        labWebsite: values?.labWebsite,
        byName: "lab",
        activeOnPortal: false,
      };
      const response = await CreateLab(inputData);
      const mappedData = {};
      Object.entries(response).forEach(([key, value]) => {
        if (value !== null) {
          mappedData[key] = value;
        }
      });
      const tableData = {
        searchByName: mappedData?.searchByName,
        Action: mappedData?.id,
        LabName: mappedData?.labName,
        Email: mappedData?.labEmail,
        Phone: mappedData?.labOfficePhone,
        Website: mappedData?.labWebsite,
        createdAt: mappedData?.createdAt,
      };

      const sortByCreatedAt = (data) =>
        data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      setLabData((previous) => sortByCreatedAt([...previous, tableData]));
      setDataSource((previous) => sortByCreatedAt([...previous, tableData]));

      setIsModalOpen(false);
      form.resetFields();
      setSuccessModel(true);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
      console.log(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const handleSearch = async (e) => {
    const currValue = e.target.value.trim();
    const searchFields = ["LabName", "Website", "Phone", "Speciality"];
    const filteredData = search(labData, currValue, searchFields);
    setDataSource(filteredData);
  };

  const handleChange = async (value) => {
    try {
      setSelectedValue(value);
      setLoading(true);
      const filterData = await handleStatusChange(
        value,
        setLabrows,
        ListLabs,
        labData
      );
      setDataSource(filterData);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const deleteSurgicalCenter = async () => {
    try {
      setDeleteLoading(true);
      await DeleteService(deleteId, DeleteLab);
      setDeleteModelPrompt(false);
      setSuccessModel(true);
      setSelectedValue(null);
      fetchData();
      setTimeout(() => {
        setSuccessModel(false);
      }, 3000);
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Typography.Title level={4} className="text-center mb-0">
        Labs
      </Typography.Title>
      <Divider />

      <Row justify="space-between table-header">
        <Row align="middle">
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search"
            className="searchbar"
            onChange={handleSearch}
            style={{ width: 250 }}
          />
        </Row>

        <Row className="gap-10 mtr-20 bold-font filter-dropdown-list">
          <Select
            allowClear
            placeholder="Status"
            style={{ width: 100 }}
            onChange={handleChange}
            value={selectedValue}
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            <Option value="ACTIVE">ACTIVE</Option>
            <Option value="INACTIVE">INACTIVE</Option>
          </Select>
          <CSVLink
            data={resData}
            headers={headers}
            filename={"Labs.csv"}
            className="export-btn"
          >
            <img src={exportCSV} alt="" className="action-icons" />
          </CSVLink>

          <Button className="blue-btn inherit-btn" onClick={showModal}>
            Add New
          </Button>
        </Row>
      </Row>

      {loading ? (
        <TableSkeleton />
      ) : (
        <Table
          columns={columns}
          dataSource={dataSource}
          className="common-table"
          scroll={{ x: 992 }}
          pagination={{ position: ["", "bottomCenter"] }}
        />
      )}

      <Modal
        className="form-modal"
        centered
        footer={null}
        width={700}
        title={
          <Typography.Title level={3} className="modal-title">
            Add Lab center
          </Typography.Title>
        }
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          onFinish={createlabCenter}
          autoComplete="off"
          layout="vertical"
          form={form}
          onFieldsChange={handleFormChange}
        >
          <Row gutter={20}>
            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="Lab name"
                name="labName"
                rules={[
                  {
                    required: true,
                    message: "Please enter a name",
                  },
                  {
                    pattern: servicesNamePattern,
                    message: "Please enter a valid name",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="Lab website"
                name="labWebsite"
                rules={[
                  {
                    pattern: urlPattern,
                    message: "Please input valid url",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="Phone"
                name="labOfficePhone"
                rules={[
                  {
                    pattern: tenDigit,
                    message: "Please enter a valid phone number",
                  },
                ]}
              >
                <InputNumber
                  controls={false}
                  formatter={(value) => formatNumberUS(value)}
                  parser={(value) => {
                    const cleanedValue = value.replace(/\D/g, "");
                    return cleanedValue.slice(0, 10);
                  }}
                
                  style={{ width: "100%", borderRadius: "5px" }}
                />
              </Form.Item>
            </Col>

            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="Lab email"
                name="labEmail"
                rules={[
                  {
                    pattern: emailPattern,
                    message: "Please enter a valid email",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={24} md={24} xs={24} sm={24} className="center-btn">
              <Button
                className="theme-btn"
                htmlType="submit"
                loading={createLoading}
                disabled={submitDisabled}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <SuccessModel
        open={successModel}
        message={
          deleteId !== ""
            ? "Lab Center Deleted Successfully"
            : "Lab Center Added Successfully"
        }
      />

      <DeleteModal
        content="Are you sure you want to delete the lab center?"
        open={deleteModelPrompt}
        onClick={deleteSurgicalCenter}
        buttonLoading={deleteLoading}
        onOk={handleOk}
        onCancel={handleCancel}
        buttonText="Yes"
      />
    </>
  );
}
